import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getProductOrdersRequest,
  getProductOrdersSuccess,
  getProductOrdersFailure,
  bookNowStatusChangeRequest,
  bookNowStatusChangeSuccess,
  bookNowStatusChangeFailure,
  changeProdStatusRequest,
  changeProdStatusSuccess,
  changeProdStatusFailure,
} from "./productOrdersSlice";
import { toast } from "react-toastify";

function* fetchProductOrders(action) {
  try {
    const payload = action.payload || {};
    const { start = 0, limit = 10, search = "" } = payload;

    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/product/getProductOrders`,
        {
          params: { start, limit, search },
        }
      )
    );
    yield put(
      getProductOrdersSuccess({
        data: response.data.data.data,
        total: response.data.data.total,
        meta: { page: start, limit },
      })
    );
  } catch (error) {
    yield put(getProductOrdersFailure(error.message));
    toast.error("Failed to fetch product orders");
  }
}

function* bookNowStatusChange(action) {
  try {
    const { id, bookingstatus } = action.payload;

    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/product/bookNowStatusChange`,
        { id, bookingstatus: bookingstatus }
      )
    );

    yield put(bookNowStatusChangeSuccess());

    toast.success(response.data.data || "Status Updated Successfully");

    yield put(getProductOrdersRequest({ start: 0, limit: 10 }));
  } catch (error) {
    yield put(bookNowStatusChangeFailure(error.message));
    toast.error(error.response?.data?.error || "Failed to update status");
  }
}

function* changeProdStatus(action) {
  try {
    const { order_id, status } = action.payload;

    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/product/changeProdStatus`,
        { order_id: order_id, status }
      )
    );

    yield put(changeProdStatusSuccess());

    toast.success(response.data.data || "Status Updated Successfully");

    yield put(getProductOrdersRequest({ start: 0, limit: 10 }));
  } catch (error) {
    yield put(changeProdStatusFailure(error.message));
    toast.error(
      error.response?.data?.message || "Failed to change product status"
    );
  }
}

export function* productOrdersSaga() {
  yield takeLatest(getProductOrdersRequest.type, fetchProductOrders);
  yield takeLatest(bookNowStatusChangeRequest.type, bookNowStatusChange);
  yield takeLatest(changeProdStatusRequest.type, changeProdStatus);
}
